import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const updateSurfaceQuestionnaireNodeMutation = gql`
  mutation updateSurfaceQuestionnaireNode(
    $input: UpdateSurfaceQuestionnaireNodeInput!
  ) {
    updateSurfaceQuestionnaireNode(input: $input) {
      success
      error
      data {
        ...surfaceNodeUnionDetails
      }
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(updateSurfaceQuestionnaireNodeMutation);
